import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_code_text = _resolveComponent("ontos-code-text")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, {
    label: _ctx.label,
    class: _normalizeClass(_ctx.clazz),
    "model-value": _ctx.value,
    readonly: _ctx.readonly,
    "onUpdate:modelValue": _ctx.onInput,
    ref: "textField",
    key: _ctx.aliasKey,
    onBlur: _ctx.onBlur,
    "error-messages": _ctx.errorMessages,
    density: _ctx.dense ? 'compact' : undefined,
    "hide-details": _ctx.hideDetails,
    hint: _ctx.hint,
    "persistent-hint": !!_ctx.hint,
    "append-inner-icon": _ctx.manual && !_ctx.readonly ? 'mdi-refresh-auto' : undefined,
    "onClick:appendInner": _ctx.onChangeToAuto
  }, {
    message: _withCtx(({message}) => [
      _createVNode(_component_ontos_code_text, { text: message }, null, 8, ["text"])
    ]),
    _: 1
  }, 8, ["label", "class", "model-value", "readonly", "onUpdate:modelValue", "onBlur", "error-messages", "density", "hide-details", "hint", "persistent-hint", "append-inner-icon", "onClick:appendInner"]))
}